import { TIMER_DURATION, QUESTION_COUNT } from '../config.js'

export default function StartScreen({ onStart }) {
  return (
    <div className="screen start-screen">
      <div className="game-logo-wrapper">
        <img src="./CityScape_sun.svg" alt="" className="game-logo-sun" />
        <img src="./CityScape_text.svg" alt="CityScape" className="game-logo-text" />
      </div>
      <p className="game-title">Reconnais {QUESTION_COUNT} villes du monde en {TIMER_DURATION} secondes chacune.</p>
      <button className="start-btn" onClick={onStart}>Start</button>
    </div>
  )
}